<ng-container *ngIf="loading else otpTemplate">
	<div>
		<app-kamona-loading [parentHeight]="'270'"></app-kamona-loading>
	</div>
</ng-container>
<ng-template #otpTemplate>
	<app-kamona-layout [heightUnit]="heightUnit.PX" [minHeight]="188">
		<div content>
			<div class="m-t-24">
				<app-kamona-password-input [input]="otp">
				</app-kamona-password-input>
			</div>
			<div class="m-t-7">
				<div nz-row nzJustify="space-between">
					<div>
						<app-otp-count-down (emitRetryAction)="retryOtp()" [countdownType]="countdownType"
											[errorMessage]="otpErrorMessage">
						</app-otp-count-down>
					</div>
					<div>
						<div class="phone-verification-hint">
							{{form.value?.otp?.length || 0}}/6
						</div>
					</div>
				</div>
			</div>
			<div class="m-t-24">
				<app-ussd-board [ussdCode]="ussdCode"></app-ussd-board>
			</div>
		</div>
		<div footer>
			<div class="m-t-32">
				<div [nzGutter]="40" nz-row nzAlign="middle" nzJustify="end">
					<div nz-col>
						<div [ngClass]="{'gray-out':submitting}" (click)="goBack()" class="back-btn">
							Back
						</div>
					</div>
					<div nz-col>
						<div style="width: 136px">
							<div [ngClass]="{'gray-out':submitting}" class="kamona-button-session">
								<app-kamona-custom-button (submitForm)="next()"
														  [isBlock]="true"
														  [isDisabled]="!form?.valid"
														  [state]="'primary'"
														  [isSubmitting]="submitting" text="Next">
								</app-kamona-custom-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</app-kamona-layout>
</ng-template>
